import React from 'react'
import {BASIC_FEATURE_DESCRIPTION, URL_YUQUE_FEATURES} from '../../../constants/CyHomepage'
import { BasicFeatureCard } from '../components/BasicFeatureCard'
import {diffEndJump} from "../../../utils/tools";

const BasicFeaturePanel: React.FC<{
    isInScreen: boolean
}> = ({
          isInScreen = false
      }) => {

    function clickStat(category, page) {
        // 统计卡片点击流量
        if (window) {
            // 用 stat-portrait
            // @ts-ignore
            window.xqui.useStat({
                action: 'click',
                category: category,
                bizType: 5,
                page: page
            })
        }

        diffEndJump({
            href: URL_YUQUE_FEATURES,
            isOpenNewWindow: true
        })
    }

    return (
        <div className='basic-feature-panel-children'>
            <div className='description-cards'>
                {
                    BASIC_FEATURE_DESCRIPTION.map((item, index) => (
                        <div className={`description-card ${isInScreen ? 'animated fadeInUp' : ''}`}
                             style={{ animationDuration: `${index > 1 ? `${1.5 + index * 0.3}s` : '1s'}` }}
                             onClick={() => clickStat(item.category, item.page)}>

                            <BasicFeatureCard
                                key={index}
                                title={item.title}
                                descriptions={item.descriptions}
                                iconStyle={item.iconStyle}
                                imgUrl={item.imgUrl}
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default BasicFeaturePanel
